import get from 'lodash/get'

const selectRangeStart = state => get(state, 'navigation.rangeStart')
const selectRangeEnd = state => get(state, 'navigation.rangeEnd')
const selectCurrentOrganizationId = state =>
  get(state, 'navigation.currentOrganizationId')

export { selectRangeStart, selectRangeEnd, selectCurrentOrganizationId }
